import { Button } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback, useState } from 'react';

import { renderModel } from '../../../util/renderModel';
import { EndLiveChatModal } from '../EndLiveChatModal';
import { headerFullPageDataHooks } from '../HeaderFullPage/HeaderFullPage.dataHooks';

export type EndLiveChatButtonProps = {
  isMobileView?: boolean;
};

const isCopilot = renderModel.isCopilot();
const isEditor3 = renderModel.isEditor3();
const isStudioEditor = renderModel.isStudioEditor();

export const EndLiveChatButton: FC<EndLiveChatButtonProps> = ({ isMobileView }) => {
  const { t } = useTranslation();
  const [isModalOpened, setModalOpened] = useState(false);

  const onCloseModal = useCallback(() => setModalOpened(false), []);
  const onOpenModal = useCallback(() => setModalOpened(true), []);

  if (isCopilot) {
    return (
      <>
        <EndLiveChatModal isOpen={isModalOpened} onCloseModal={onCloseModal} isMobileView={isMobileView} />
        <Button
          size="tiny"
          onClick={onOpenModal}
          dataHook={headerFullPageDataHooks.endLiveChat()}
          skin="dark"
          priority="secondary"
        >
          {t('live_chat_close_btn')}
        </Button>
      </>
    );
  }
  return (
    <>
      <EndLiveChatModal isOpen={isModalOpened} onCloseModal={onCloseModal} isMobileView={isMobileView} />
      <Button
        skin={isEditor3 || isStudioEditor ? 'dark' : 'transparent'}
        priority={isEditor3 || isStudioEditor ? 'secondary' : 'primary'}
        onClick={onOpenModal}
        dataHook={headerFullPageDataHooks.endLiveChat()}
        size="medium"
      >
        {t('live_chat_close_btn')}
      </Button>
    </>
  );
};
